import {PcsDetailType, PcsSubjectElementType} from "../interface";

const today = new Date();
const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);


export const pcsDetailInit: PcsDetailType = {
    purchaseOrderId: 0,
    purchaseOrderNo: '',
    newDtRequestShipment: '',
    purchaseOrderDt: '',
    newTxtCollection: '',
    purchaseOrderState: 1,
    newPShipment: 0,
    newPPayment: 0,
    createdon: '',
    modifiedon: '',
    newLRecipientValue: '',
    newLAddressValue: '',
    newLInvoiceAgentValue: '',
    purchaseOrderer: 0,
    customerMemo: '',
    memo: '',
    newPShipmentName: '',
    shipmentNo: '',
    ordererName: '',
    paymentName: '',
    recipientName: '',
    recipientMobile: '',
    purchaseOrderStateName: '',
    progressName: '',
    taxCharge: '',
    taxEmail: '',
    taxMobile: '',
    addressName: '',
    postCode: '',
    address1: '',
    address2: '',
    newDtEstimatedCollection: '',
    subjectList: [],

    customPostcode: '',
    customAddress1: '',
    customAddress2: '',

    newShipmentId: '',
    newDtShipment: '',

    newLEnduserValue: '',
    enduserName: '',

    newLContactValue: '',
    contactName: '',

    owneridValue: '',
    owningUserName: '',

    deliveryConfirmFile: null,
    invoiceNo: ''
}

export const pcsSubjectElementInit: PcsSubjectElementType = {
    purchaseOrderSubjectId: 0,
    purchaseOrderId: 0,
    newLErpProductValue: '',
    newTxtStandard: '',
    createdon: '',
    newIQty: 0,
    productName: '',
    productGroupName: '',
    productRange: '',
    newProductGroupid: '',
    newLProductGroupValue: '',
};
